import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapFootnoteSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapfootnote: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      definingForContent: true,
      parseDOM: [{
        tag: 'MadCap\\:footnote'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:footnote'
    }
  } satisfies Record<string, NodeSpec>;
}
